// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V21k_","title":"styles_title__2RZxi"};